module.exports = __webpack_public_path__ + "img/octagon-half.30d728a5.svg";